import * as Api from '@ViewModels';
import { ISelectBoxOption } from '../../../../web/components/SelectBox';

export const IndustryOptions: ISelectBoxOption<Api.Industry | string>[] = [
	{ title: 'Select One', value: '' },
	...Api.AllIndustries.map(industry => {
		return {
			title: industry,
			value: industry,
		};
	}),
];
